import React, { FC, useState } from 'react';

import { Button } from '../../../common/components/Button';
import { IImage } from '../../../common/messageCreators';
import { MessageItem } from '../MessageItem';
import { ImageModal } from './ImageModal';
import s from './styles.scss';

export const Image: FC<IImage> = ({ id, src, avatar }) => {
  const [isModalOpen, toggleModal] = useState<boolean>(false);

  const modal = isModalOpen && <ImageModal src={src} close={() => toggleModal(false)} />;

  return (
    <MessageItem id={id}>
      <div className={s.box}>
        <Button blank link={src} aria-label="open image">
          <img src={src} className={s.image} alt="" />
        </Button>
      </div>
      {modal}
    </MessageItem>
  );
};
